<template>
  <v-layout class="mb-3">
    <v-flex shrink>
      <v-card width="250px" class="elevation-5" style="border-radius: 16px">
        <v-list class="py-0" style="background-color: #000">
          <v-list-tile>
            <v-list-tile-title
              style="text-align: center; font-size: 20px; color: white"
              >ORDER WESMART</v-list-tile-title
            >
          </v-list-tile>
        </v-list>

        <v-list dark class="py-0" style="background-color: #424242">
          <v-list-tile
            v-for="item in menuItems"
            :key="item.status"
            :to="item.link"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="white--text">{{
              item.status
            }}</v-list-tile-content>
          </v-list-tile>
        </v-list>
        <!-- <v-tooltip right>
          <v-list
            dark
            class="py-0 my-list"
            slot="activator"
            style="background-color: #424242"
          >
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>mdi-cog</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="white--text"
                >Auto Order</v-list-tile-content
              >
              <v-list-tile-action style="padding-left: 10px">
                <v-switch
                  @change="fethcUpdate()"
                  :loading="switch_loading"
                  v-model="model"
                  color="yellow"
                ></v-switch>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <span>Switch auto order or manual</span>
        </v-tooltip> -->
        <!-- <v-list dark class="py-0" style="background-color:#424242;">
          <v-list-tile>
          <v-list-tile-action>
          <v-icon>access_alarm</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="white--text">Pre order</v-list-tile-content>
          <v-list-tile-action>
            <v-btn fab color="primary" style="height:28px;width:28px;" class="black--text">{{ order_count.me_order_status['order_status_'+item.check]+ order_count.we_order_status['order_status_'+item.check]}}</v-btn>
          </v-list-tile-action>
          </v-list-tile>
        </v-list>-->
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      order_status: 1,
      interval_order: null,
      interval_list: 0,
      // model: null,
      switch_loading: false,
      menuItems: [
        {
          icon: "new_releases",
          status: "New Order",
          check: "new_order",
          order_status: 1,
          link:
            "/weserve_admin_login/orderwesmart/" +
            this.$store.state.backOffice.province +
            "/orderlist/ordermade",
          action: "1",
        },
        {
          icon: "motorcycle",
          status: "On Process",
          check: "on_process",
          order_status: 2,
          link:
            "/weserve_admin_login/orderwesmart/" +
            this.$store.state.backOffice.province +
            "/orderlist/onprocess",
          action: "1",
        },

        {
          icon: "check_circle",
          status: "Completed",
          check: "complete",
          order_status: 3,
          link:
            "/weserve_admin_login/orderwesmart/" +
            this.$store.state.backOffice.province +
            "/orderlist/completed",
          action: "55",
        },
        {
          icon: "cancel",
          status: "Cancelled",
          check: "cancel",
          order_status: 4,
          link:
            "/weserve_admin_login/orderwesmart/" +
            this.$store.state.backOffice.province +
            "/orderlist/cancel",
          action: "32",
        },
        {
          icon: "mdi-receipt-text-clock",
          status: "Pending",
          check: "cancel",
          order_status: 4,
          link:
            "/weserve_admin_login/orderwesmart/" +
            this.$store.state.backOffice.province +
            "/orderlist/pending",
          action: "32",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      // fetchGetAutoOrder: "fetchOrderListBack/fetchAutoOrder",
      // fetchUpdateAutoOrder: "fetchOrderListBack/fetchUpdateAutoOrder",
    }),
    // async getData() {
    //   await this.fetchGetAutoOrder(this.$store.state.backOffice.province);
    //   if (this.auto_Order.auto_order_status == 0) {
    //     this.model = false;
    //   } else {
    //     this.model = true;
    //   }
    // },
    // async fethcUpdate() {
    //   this.switch_loading = true;
    //   await this.fetchUpdateAutoOrder(this.$store.state.backOffice.province);
    //   this.switch_loading = false;
    // },
  },
  computed: {
    ...mapState({
      selectedMenu: (state) => state.backOffice.selectedMenu,
      // auto_Order: (state) => state.fetchOrderListBack.auto_Order,
      // updateAutoOrder: (state) => state.fetchOrderListBack.updateAutoOrder,
    }),
  },
  destroyed() {},
  created() {
    // this.getData();
  },
};
</script>
